import { Controller } from '@hotwired/stimulus'
import { template, escape } from "lodash"
import plupload from "plupload"

export default class extends Controller {
  static targets = ["progressTemplate", "completedTemplate", "fileList"]

  static values = {
    setup: Object,
    uploadKey: String
  }

  takenNames = []
  pluploadRun = false
  pendingFile = null

  connect() {
    console.log("uploader run")
    this.progressTemplate = template(this.progressTemplateTarget.innerHTML)
    this.completedTemplate = template(this.completedTemplateTarget.innerHTML)

    window.addEventListener("upload-file", this.convertFromBase64AndUpload.bind(this))

    if (!this.uploader) {
      this.pluploadInit()
    }
  }

  upload() {
    if (!this.pluploadRun) {
      this.pluploadInit()
      document.querySelector('#container_attachment input[type=file]').click()
    }
  }

  convertFromBase64AndUpload(event) {
    const blob = atob(event.detail.fileBase64)
    const filename = event.detail.filename
    const array = new Uint8Array(blob.length)
    for (let i = 0; i < blob.length; i++) {
      array[i] = blob.charCodeAt(i)
    }
    const file = new File([array], `${filename}`)
    if (!this.uploader) {
      this.pluploadInit()
    }

    if (this.pluploadRun) {
      this.uploader.addFile(file)
    } else {
      this.pendingFile = file
    }
  }

  trimFileName(fileName) {
    const ext = fileName.split('.').pop()
    let name = !ext ? fileName : fileName.substring(0, fileName.length - (ext.length + 1))
    while ((this.uploadKeyValue + encodeURIComponent(ext ? name + '.' + ext : name)).replaceAll('(', '%28').replaceAll(')', '%29').length > 253 || name.slice(-1) === " ") {
      name = name.substring(0, name.length - 1)
    }

    return ext ? name + '.' + ext : name
  }

  pluploadInit() {
    const config = {
      browse_button: "pick-files",
      container: "container_attachment",
      drop_element: "container_attachment",
      init: {
        PostInit: () => {
          this.pluploadRun = true
          if (this.pendingFile) {
            this.uploader.addFile(this.pendingFile)
            this.pendingFile = null
          }
        },
        FilesAdded: (up, files) => {
          for (let i = 0; i < files.length; i++) {
            this.itemData = {
              id: files[i].id,
              name: escape(files[i].name) + ' (' + plupload.formatSize(files[i].size) + ')'
            }
            this.fileListTarget.insertAdjacentHTML('beforeend', this.progressTemplate(this.itemData))
            this.showFileList()
          }
          up.start()
        },
        UploadProgress: (up, file) => {
          const elem = document.querySelector("#file-" + file.id + " [data-attachment-name]")
          if (elem) {
            elem.innerHTML = file.percent + "%"
          }
        },
        FileUploaded: (up, file) => {
          this.itemData = {
            id: file.id,
            url: this.uploadKeyValue + encodeURIComponent(file.name),
            name: escape(file.name)
          }
          this.fileListTarget.insertAdjacentHTML('beforeend', this.completedTemplate(this.itemData))
          document.querySelector("#file-" + file.id).remove()
          this.showFileList()
          window.dispatchEvent(new CustomEvent("file-uploaded"))
        },
        Error: (up, err) => {
          console.log("\nError #" + err.code + ": " + err.message)
          this.fileListTarget.innerText = "Wystąpił błąd"
        },
        BeforeUpload: (up, file) => {
          file.name = this.patchName(file.name)
          up.settings.multipart_params.key = this.uploadKeyValue + file.name
          up.settings.multipart_params.Filename = file.name
        }
      }
    }

    this.uploader = new plupload.Uploader(Object.assign(config, this.setupValue))
    this.uploader.init()
  }

  patchName(fileName) {
    let newName = fileName
    let i = 2
    while (this.takenNames.includes(newName)) {
      newName = i + "_" + fileName
      ++i
    }
    this.takenNames.push(newName)

    newName = this.trimFileName(newName)
    return newName
  }

  showFileList() {
    this.fileListTarget.classList.remove("hidden")
  }

  hideFileList() {
    const visibleItems = Array.from(this.fileListTarget.children).filter(
      el => !el.classList.contains("hidden")
    )
    if (visibleItems.length === 0) {
      this.fileListTarget.classList.add("hidden")
    }
  }

  delete(event) {
    const confirmed = confirm(event.currentTarget.getAttribute("data-confirm"))
    if (confirmed) {
      const item = document.querySelector("[data-file='" + event.params.id + "']")
      if (!item) return

      const checkbox = item.querySelector("input[type='checkbox']")
      if (checkbox) {
        checkbox.checked = true
      }

      item.classList.add("hidden")
      this.hideFileList()
    }
  }

  disconnect() {
    window.removeEventListener("upload-image", this.convertFromBase64AndUpload.bind(this))

    if (this.uploader) {
      this.uploader = null
      this.pluploadRun = false
      this.pendingFile = null
    }
  }
}
